export default __webpack_public_path__ + "static/eneAcademyHeroProfile-53c7823770dd5160c0c9584705f4dc11.png";